import React, { useState } from 'react';
import { ContactForm } from './ContactForm';
import Meta from './Meta';

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
};

const modalStyle = {
  position: 'relative',
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '30px 40px 40px',
  maxWidth: '600px',
  width: '90%',
  boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
};

export default function DedicatedChannels() {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
      <React.Fragment>
     <Meta
         title="Аренда выделенного интернет-канала для бизнеса с гарантированной скоростью"
         description="Выделенный (закрепленный) IP-канал связи без ограничения скорости. Идеально для серверов, видеоконференций и CRM-систем. Подключение в Подольске, Москве и области за 3-5 дней."
      />
    <div
      style={{
        fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
        maxWidth: '900px',
        margin: '0 auto',
        padding: '40px 20px',
        lineHeight: 1.6,
        backgroundColor: '#f9f9f9',
        color: '#333',
      }}
    >
      <h1
        style={{
          textAlign: 'center',
          marginBottom: '30px',
          fontSize: '2.5em',
          color: '#34495e',
        }}
      >
        Выделенные каналы связи для вашего бизнеса от "ИТ Особа"
      </h1>

      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Обеспечьте стабильную, быструю и защищенную связь с помощью выделенных каналов для передачи данных.
          Наш сервис гарантирует высокое качество связи и надежность для любых бизнес-задач.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Что такое выделенный канал связи?</h2>
      <p style={{ fontSize: '1.2em', marginBottom: '20px' }}>
        Выделенный канал связи — это физическая или виртуальная линия передачи данных, предназначенная исключительно для вашей компании. Это позволяет обеспечить высокую скорость, низкие задержки и максимальную безопасность при передаче информации, не разделяя канал с другими пользователями.
      </p>

      <h2 style={{ marginTop: '30px', color: '#34495e' }}>Преимущества наших выделенных каналов</h2>

      <ul style={{ listStyleType: 'disc', paddingLeft: '20px', fontSize: '1.2em' }}>
        <li style={{ marginBottom: '10px' }}>Гарантированная скорость передачи данных без снижения качества даже в пиковые часы.</li>
        <li style={{ marginBottom: '10px' }}>Высокий уровень безопасности: выделенный канал не используется другими абонентами.</li>
        <li style={{ marginBottom: '10px' }}>Стабильная и бесперебойная работа благодаря профессиональному оборудованию и круглосуточному мониторингу.</li>
        <li style={{ marginBottom: '10px' }}>Поддержка различных типов подключения — оптоволокно, Ethernet и др., адаптация под потребности бизнеса.</li>
        <li style={{ marginBottom: '10px' }}>Возможность резервирования каналов для повышения надежности и отказоустойчивости.</li>
        <li style={{ marginBottom: '10px' }}>Техническая поддержка 24/7 от команды опытных специалистов.</li>
        <li style={{ marginBottom: '10px' }}>Конкурентные цены и гибкие условия договора под любые масштабы бизнеса.</li>
      </ul>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        {/* <button
          onClick={openModal}
          style={{
            backgroundColor: '#2980b9',
            color: '#fff',
            border: 'none',
            borderRadius: '6px',
            padding: '14px 30px',
            fontSize: '1.1em',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#2471a3')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#2980b9')}
        >
          Оставить заявку
        </button> */}
      </div>

      {modalOpen && (
        <div style={overlayStyle} onClick={closeModal} role="dialog" aria-modal="true" aria-labelledby="modal-title">
          <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                position: 'absolute',
                top: 12,
                right: 12,
                width: 32,
                height: 32,
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: '#f0f0f0',
                color: '#333',
                fontSize: 24,
                fontWeight: 'bold',
                lineHeight: '32px',
                textAlign: 'center',
                boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                transition: 'background-color 0.3s, color 0.3s, box-shadow 0.3s',
                userSelect: 'none',
              }}
              onClick={closeModal}
              aria-label="Закрыть"
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.color = '#000';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#f0f0f0';
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.boxShadow = '0 2px 6px rgba(0,0,0,0.15)';
              }}
              onMouseDown={(e) => {
                e.currentTarget.style.backgroundColor = '#d0d0d0';
                e.currentTarget.style.boxShadow = 'inset 0 2px 4px rgba(0,0,0,0.2)';
              }}
              onMouseUp={(e) => {
                e.currentTarget.style.backgroundColor = '#e0e0e0';
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
              }}
            >
              ×
            </div>
            <ContactForm />
          </div>
        </div>
      )}
    </div>
    </React.Fragment>
  );
}